import React, { useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { ref, set } from 'firebase/database';
import { useAuth } from '../context/AuthContext';
import { generateId } from '../firebase/idGenerator';
import './StaticPages.css';

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', type: 'general', message: '' });
  const [status, setStatus] = useState("");
  const { userProfile } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const msgId = await generateId('MSG');
      const msgRef = ref(db, `contactMessages/${msgId}`);
      
      await set(msgRef, {
        msgId: msgId,
        name: formData.name,
        email: formData.email,
        type: formData.type,
        message: formData.message,
        suid: userProfile?.suid || "anonymous",
        priority: formData.type === 'security' ? 'critical' : 'medium',
        createdAt: Date.now()
      });
      setStatus("Message successfully transmitted to our neural support queue.");
      setFormData({ name: '', email: '', type: 'general', message: '' });
    } catch (err) {
      setStatus("Neural transmission failed. Please verify your connection.");
      console.error(err);
    }
  };

  return (
    <div className="static-page-wrapper animate-up">
      <div className="static-content-card">
        <div className="static-page-header">
          <h1 className="static-page-title">Neural Support</h1>
          <span className="static-page-version">Response Pipeline v4.0.0.15</span>
          <p className="static-page-subtitle">Priority triage for verified developers. Include your <strong>SUID</strong> for cryptographic case identification.</p>
          <div className="static-page-divider"></div>
        </div>

        <div className="static-form-wrapper">
          {status && (
            <div style={{background: 'rgba(0, 255, 174, 0.1)', border: '1px solid rgba(0, 255, 174, 0.2)', color: '#00ffae', padding: '15px 20px', borderRadius: '12px', marginBottom: '30px', textAlign: 'center', fontWeight: '600'}}>
              <i className="fa-regular fa-circle-check" style={{marginRight: '8px'}}></i> {status}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
              <div className="static-form-group">
                <label className="static-form-label">Full Name</label>
                <input 
                  type="text" 
                  className="static-form-input" 
                  required
                  value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})}
                  placeholder="Developer Name"
                />
              </div>
              <div className="static-form-group">
                <label className="static-form-label">Email Address</label>
                <input 
                  type="email" 
                  className="static-form-input" 
                  required
                  value={formData.email}
                  onChange={e => setFormData({...formData, email: e.target.value})}
                  placeholder="dev.alias@example.com"
                />
              </div>
            </div>

            <div className="static-form-group">
              <label className="static-form-label">Inquiry Triage Tier</label>
              <select 
                className="static-form-input"
                style={{appearance: 'none', background: 'var(--surface-2)', cursor: 'pointer'}}
                value={formData.type}
                onChange={e => setFormData({...formData, type: e.target.value})}
              >
                <option value="general">General Platform Inquiry</option>
                <option value="security">Security / Account Restriction Appeal</option>
                <option value="technical">Technical Integration (API/Embed) Help</option>
                <option value="business">Business / Verification Audit Request</option>
              </select>
            </div>

            <div className="static-form-group">
              <label className="static-form-label">Communication Node</label>
              <textarea 
                className="static-form-input" 
                required
                rows="6"
                style={{resize: 'none'}}
                value={formData.message}
                onChange={e => setFormData({...formData, message: e.target.value})}
                placeholder={userProfile ? `Active SUID: ${userProfile.suid} detected. Provide further context...` : "Provide detailed context. (Note: Include SUID for faster triage)"}
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary btn-glow" style={{width: '100%', marginTop: '10px', padding: '16px', fontSize: '1.1rem', borderRadius: '14px', fontWeight: '700'}}>
              Transmit Message <i className="fa-regular fa-paper-plane" style={{marginLeft: '8px'}}></i>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
